const validateEmail = (email: string) =>
  /^[^@ ]+@[^@ ]+\.[^@ \.]+$/.test(email);
export const isValidEmail = function (value: string) {
  return validateEmail(value);
};
